module.exports = __webpack_public_path__ + "static/media/invalid.61399d2a.svg";